// extracted by mini-css-extract-plugin
module.exports = {"NoLatestNewsContainer":"no-latest-news_NoLatestNewsContainer__5j9bV"};